import { Link } from "react-router-dom";
import { Home } from "lucide-react";
import { Button } from "@/components/ui/button";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { useLang } from "@/i18n/LanguageContext";
import { homePath } from "@/i18n/slugs";

const texts = {
  fr: {
    title: "Page introuvable",
    text: "La page que vous recherchez n'existe pas ou a été déplacée.",
    btn: "Retour à l'accueil",
  },
  nl: {
    title: "Pagina niet gevonden",
    text: "De pagina die u zoekt bestaat niet of werd verplaatst.",
    btn: "Terug naar de startpagina",
  },
};

export default function NotFound() {
  const { lang } = useLang();
  const t = texts[lang];

  return (
    <div className="min-h-screen bg-white" data-testid="not-found-page">
      <Navbar />
      <section className="pt-32 pb-20 lg:pt-40 lg:pb-32">
        <div className="max-w-xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <p className="font-heading text-7xl font-bold text-orange-500 mb-4">404</p>
          <h1 className="font-heading text-2xl font-bold text-slate-900 mb-3">
            {t.title}
          </h1>
          <p className="text-slate-600 mb-8">
            {t.text}
          </p>
          <Link to={homePath(lang)}>
            <Button className="bg-orange-500 hover:bg-orange-600 text-white font-semibold gap-2" data-testid="not-found-home-button">
              <Home className="w-4 h-4" />
              {t.btn}
            </Button>
          </Link>
        </div>
      </section>
      <Footer />
    </div>
  );
}
